<template lang='pug'>
v-layout.column
  v-layout(row wrap class='mb-1')
    v-flex(text-xs-left)
      h2 ユーザー編集 {{ getCompanyName }} 様

  v-layout(row wrap class='mb-2')
    v-flex(xs12)
      TheUserForm(action='edit')
</template>

<script>
import TheUserForm from '../../components/TheUserForm'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EditUser',

  components: {
    TheUserForm
  },

  computed: {
    ...mapGetters('user', [
      'getCompanyName',
    ]),
  },

  async created() {
    const params = {
      company_id: this.$route.params.company_id,
      user_id: this.$route.params.user_id,
    }
    await this.edit(params)
    await this.fetchCompany(params)
  },

  methods: {
    ...mapActions('user', [
      'edit',
      'fetchCompany',
    ]),
  },
}
</script>

<style lang='scss' scoped>
</style>
